import React, { useEffect, useState } from "react";
import {
  Dialog,
  List,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { useSelector } from "react-redux";
import { useStyles } from "./BoxDialog.styles";
import { ButtonSubmit } from "../ButtonSubmit/ButtonSubmit";
import { SelectDropDown } from "../Select/SelectDropDown";
import { useIntl } from "react-intl";
import MTable from "../MTable/MTable";
import { Pagination } from "../MTable/Localization";
import { useDispatch } from "react-redux";
import DocumentGroupServices from "../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import CustomerServicesApi from "../../Redux/Actions/CustomerAction";
import { useApiValidationSnackbar } from "../Snackbar/SnackbarAlert";
import { useSnackbar } from "notistack";
import { DeleteAlert } from "./DeleteAlert";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export const BoxDialog = ({
  open,
  handleClose,
  selectdata,
  url,
  document,
  columnName,
}) => {
  const {
    userList,
    apiToken,
    allUserGroups,
    permissions,
    usersPermission,
    groupUsersPermission,
  } = useSelector((state: any) => ({
    userList: state.UserReducer.userList,
    apiToken: state.UserReducer.apiToken,
    allUserGroups: state.UserGroupReducer.allUserGroups,
    permissions: state.DocumentGroupReducer.permissions,
    usersPermission: state.CustomerReducer.usersPermission,
    groupUsersPermission: state.CustomerReducer.groupUsersPermission,
  }));
  const [selectUser, setSelectUser] = useState({
    permissionTypeGroup: "",
    selectGroup: "",
    permissionType: "",
    selectUser: "",
  });
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  let [alertUserGroupDeleteOpen, setAlertUserGroupDeleteOpen] =
    useState<any>(false);
  let [getUserGroupPermission, setGetUserGroupPermission] = useState<any>(null);
  let [alertDeleteOpen, setAlertDeleteOpen] = useState<any>(false);
  let [getPermission, setGetPermission] = useState<any>(null);
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const { pagination, toolbar, body, header } = Pagination();
  const { enqueueSnackbar } = useSnackbar();
  const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
  const permissionKey = [
    formatMessage({ id: `document.permission.read` }),
    formatMessage({ id: `document.permission.write` }),
  ];
  const userGroupType = [
    formatMessage({ id: `form.user` }),
    formatMessage({ id: `form.usergroup` }),
  ];
  const columnsGroup = [
    document === "documentGroupPermission"
      ? {
          title: formatMessage({
            id: `tab.folder`,
            defaultMessage: "Name",
          }),
          field: "documentGroup",
        }
      : {
          title: formatMessage({
            id: `document.${columnName}`,
            defaultMessage: "Name",
          }),
          field: "document",
        },
    {
      title: formatMessage({ id: "group.user", defaultMessage: "Name" }),
      field: "userGroup",
    },
    {
      title: formatMessage({
        id: "document.upload.permission",
        defaultMessage: "Name",
      }),
      field: "permission",
    },
  ];
  const columnsUser = [
    document === "documentGroupPermission"
      ? {
          title: formatMessage({
            id: `document.document`,
            defaultMessage: "Name",
          }),
          field: "documentGroup",
        }
      : {
          title: formatMessage({
            id: `document.${columnName}`,
            defaultMessage: "Name",
          }),
          field: "document",
        },
    {
      title: formatMessage({
        id: "form.firstName",
        defaultMessage: "First Name",
      }),
      field: "firstName",
    },
    {
      title: formatMessage({
        id: "form.lastName",
        defaultMessage: "Last Name",
      }),
      field: "lastName",
    },
    {
      title: formatMessage({
        id: "document.upload.permission",
        defaultMessage: "Name",
      }),
      field: "permission",
    },
  ];
  enum permissionsProps {
    "Read" = 1,
    "Write" = 2,
    "Läsa" = 1,
    "Läsa/Skriva" = 2,
  }
  const createPermission = (groupType) => {
    let permissionParam: any;
    if (groupType === "User") {
      if (document == "documentPermission") {
        permissionParam = {
          userId: selectUser?.selectUser,
          permission: permissionsProps[selectUser.permissionType],
          documentId: selectdata?.id,
        };
      } else {
        permissionParam = {
          userId: selectUser?.selectUser,
          permission: permissionsProps[selectUser.permissionType],
          documentGroupId: selectdata?.id, //change documentgroupid
        };
      }
    } else {
      if (document == "documentPermission") {
        permissionParam = {
          userGroupId: selectUser?.selectGroup,
          permission: permissionsProps[selectUser.permissionTypeGroup],
          documentId: selectdata?.id,
        };
      } else {
        permissionParam = {
          userGroupId: selectUser?.selectGroup,
          permission: permissionsProps[selectUser.permissionTypeGroup],
          documentGroupId: selectdata?.id, //documentgroupid
        };
      }
    }
    let select: any = "fillpermission";
    let level: any = "permission";
    if (!selectUser?.selectGroup && !selectUser?.selectUser) {
      ErrorMessage(userList, select);
    } else if (
      !selectUser?.permissionType &&
      !selectUser?.permissionTypeGroup
    ) {
      ErrorMessage(userList, level);
    } else {
      if (document == "documentGroupPermission") {
        dispatch(
          DocumentGroupServices.documentGroupPermission(
            permissionParam,
            apiToken
          )
        );
      } else {
        dispatch(
          DocumentGroupServices.permissionGroup(permissionParam, apiToken)
        );
      }
      let permissionAdded: any = "permissionAdded";
      notifySuccess(permissions, permissionAdded);
      handleClose();
      setSelectUser({
        permissionType: "",
        selectGroup: "",
        permissionTypeGroup: " ",
        selectUser: " ",
      });
    }
  };
  let usersGroups: any;
  let usersData: any;
  if (userList?.errors != undefined || usersPermission?.errors != undefined) {
  } else {
    let usersEmailWithAccess = usersPermission?.map((x: any) => x?.user);
    usersData = userList?.filter(
      (element: any) =>
        !usersEmailWithAccess?.includes(element?.email) &&
        element?.status == "Active" &&
        element?.role != "ClientAdmin"
    );
    let usersGroupNameWithAccess = groupUsersPermission?.map(
      (x: any) => x?.userGroup
    );
    usersGroups = allUserGroups?.filter(
      (element: any) => !usersGroupNameWithAccess?.includes(element?.name)
    );
  }
  const deleteUserGroup = (user: any) => {
    return {
      tooltip: formatMessage({ id: "component.mtable.deleteTooltip" }),
      icon: "delete",
      onClick: () => {
        setAlertUserGroupDeleteOpen(true);
        setGetUserGroupPermission(user);
      },
    };
  };
  const UserGroupDeletePermission = () => {
    let customerId = selectdata?.id;
    let DOCUMENT_ADD = url;
    setLoading(true);
    dispatch(
      DocumentGroupServices.userGroupDeletePermission(
        getUserGroupPermission?.id,
        apiToken
      )
    );
    setTimeout(() => {
      dispatch(
        CustomerServicesApi.getUsersGroupPermission(
          DOCUMENT_ADD,
          customerId,
          apiToken
        )
      );
      setLoading(false);
      setAlertUserGroupDeleteOpen(false);
    }, 2000);
  };
  const deleteUsers = (user: any) => {
    return {
      tooltip: formatMessage({ id: "component.mtable.deleteTooltip" }),
      icon: "delete",
      onClick: () => {
        setAlertDeleteOpen(true);
        setGetPermission(user);
      },
    };
  };
  const deleteUserPermission = () => {
    let customerId = selectdata?.id;
    let DOCUMENT_ADD = url;
    setUserLoading(true);
    dispatch(
      DocumentGroupServices.userDeletePermission(getPermission?.id, apiToken)
    );
    setTimeout(() => {
      dispatch(
        CustomerServicesApi.getUsersPermission(
          DOCUMENT_ADD,
          customerId,
          apiToken,
          enqueueSnackbar
        )
      );
      setUserLoading(false);
      setAlertDeleteOpen(false);
    }, 2000);
  };
  const cancelFrom = () => {
    setSelectUser({
      permissionType: "",
      selectGroup: "",
      permissionTypeGroup: " ",
      selectUser: " ",
    });
    handleClose();
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        className="BoxDialog-popup"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ width: "100%" }}
          className={classes.width800}
        >
          {formatMessage({ id: `document.permission.${document}` })}
        </DialogTitle>
        <List className={classes.padding25}>
          <Grid className={classes.tableTitle}>
            {formatMessage({
              id: "header.title.user-group",
              defaultMessage: "User groups",
            })}
          </Grid>
          <MTable
            hideToolbar
            columns={columnsGroup}
            data={groupUsersPermission}
            options={{
              search: false,
              columnsButton: false,
              paging: false,
            }}
            localization={{ pagination, toolbar, body, header }}
            actions={[deleteUserGroup]}
            isLoading={loading}
          />
          <Grid
            container
            spacing={2}
            className={classes.marginTop15}
            style={{ justifyContent: "space-evenly" }}
          >
            <Grid item className={classes.addTitle}>
              {formatMessage({
                id: "group.user.permission.user.select.group",
                defaultMessage: "Choose folder",
              })}
              &nbsp;:
            </Grid>
            <Grid item xs={3}>
              <SelectDropDown
                nameid="userId"
                handleChange={(event) =>
                  setSelectUser({
                    ...selectUser,
                    selectGroup: event?.target?.value,
                  })
                }
                fieldName={"select group"}
                selctOption={usersGroups}
                selected={selectUser?.selectGroup}
                placeholder={formatMessage({
                  id: "group.selectGroup",
                  defaultMessage: "Select group",
                })}
                ClassName={classes.dropDown}
                classSelect={(classes.input, classes.inputRoot)}
              />
            </Grid>
            <Grid item className={classes.addTitle}>
              {formatMessage({
                id: "document.upload.choose.permission",
                defaultMessage: "Choose permission",
              })}
              &nbsp;:
            </Grid>
            <Grid item xs={3}>
              <SelectDropDown
                handleChange={(event) =>
                  setSelectUser({
                    ...selectUser,
                    permissionTypeGroup: event?.target?.value,
                  })
                }
                fieldName={"user"}
                OptionsValue={permissionKey}
                selected={selectUser?.permissionTypeGroup}
                placeholder={formatMessage({
                  id: "group.user.permission",
                  defaultMessage: "Select Permission",
                })}
                ClassName={classes.dropDown}
                classSelect={(classes.input, classes.inputRoot)}
              />
            </Grid>
            <Grid style={{ marginTop: "10px", marginRight: "20px" }}>
              <ButtonSubmit
                text={"model.title.save"}
                onClick={() => createPermission("Group")}
              />
            </Grid>
          </Grid>
        </List>
        <List className={classes.padding25}>
          <Grid className={classes.tableTitle}>
            {formatMessage({
              id: "admin.users.header",
              defaultMessage: "Users",
            })}
          </Grid>
          <MTable
            hideToolbar
            columns={columnsUser}
            data={usersPermission}
            options={{
              search: false,
              columnsButton: false,
              paging: false,
            }}
            localization={{ pagination, toolbar, body, header }}
            actions={[deleteUsers]}
            isLoading={userLoading}
          />
          <Grid
            container
            spacing={2}
            className={classes.marginTop15}
            style={{ justifyContent: "space-evenly", marginRight: "10px" }}
          >
            <Grid item className={classes.addTitle}>
              {formatMessage({
                id: "group.user.permission.user.select.group",
                defaultMessage: "Choose folder",
              })}
              &nbsp;:
            </Grid>
            <Grid item xs={3}>
              <SelectDropDown
                nameid="firstname"
                handleChange={(event) =>
                  setSelectUser({
                    ...selectUser,
                    selectUser: event?.target?.value,
                  })
                }
                fieldName={"Select user"}
                selctOption={usersData}
                selected={selectUser?.selectUser}
                placeholder={formatMessage({
                  id: "group.selectGroup",
                  defaultMessage: "Select users",
                })}
                ClassName={classes.dropDown}
                classSelect={(classes.input, classes.inputRoot)}
              />
            </Grid>
            <Grid item className={classes.addTitle}>
              {formatMessage({
                id: "document.upload.choose.permission",
                defaultMessage: "choose permission",
              })}
              &nbsp;:
            </Grid>
            <Grid item xs={3}>
              <SelectDropDown
                handleChange={(event) =>
                  setSelectUser({
                    ...selectUser,
                    permissionType: event?.target?.value,
                  })
                }
                fieldName={"user"}
                OptionsValue={permissionKey}
                selected={selectUser?.permissionType}
                placeholder={formatMessage({
                  id: "group.user.permission",
                  defaultMessage: "Select Permission",
                })}
                ClassName={classes.dropDown}
                classSelect={(classes.input, classes.inputRoot)}
              />
            </Grid>
            <Grid style={{ marginTop: "10px", marginRight: "10px" }}>
              <ButtonSubmit
                text={"model.title.save"}
                onClick={() => createPermission("User")}
              />
            </Grid>
          </Grid>
        </List>
        <Toolbar>
          {/* <ButtonSubmit
            text={"model.title.cancel"}
            onClick={cancelFrom}
            className={classes.padding25}
          /> */}
          <Grid container justifyContent={"flex-end"}>
            {/* <ButtonSubmit
              text={"model.title.save"}
              onClick={()=>createPermission('')}
            /> */}
            <ButtonSubmit
              text={"model.title.cancel"}
              onClick={cancelFrom}
              className={classes.padding25}
            />
          </Grid>
        </Toolbar>
      </Dialog>
      <DeleteAlert
        alertClose={() => setAlertUserGroupDeleteOpen(false)}
        alertOpen={alertUserGroupDeleteOpen}
        componentName={"admin.users.header"}
        Submited={UserGroupDeletePermission}
        deletedValue={getUserGroupPermission?.document}
      />
      <DeleteAlert
        alertClose={() => setAlertDeleteOpen(false)}
        alertOpen={alertDeleteOpen}
        componentName={"admin.users.header"}
        Submited={deleteUserPermission}
        deletedValue={getPermission?.document}
      />
    </div>
  );
};
